import React from 'react';
import MultiUserSelect from '../MultiUserSelect';
import Inputs from 'components/Inputs';
import FormInput from '../../kingpin/forms/FormInput';

const AccessInput = ({
  access,
  setUsers,
  options,
}: {
  access: ResourceAccess;
  setUsers: React.Dispatch<React.SetStateAction<string[]>>;
  options: DropdownOption[];
}) => (
  <div>
    <FormInput label={'Access'}>
      <Inputs.Dropdown options={options} />
    </FormInput>
    {access.userIds && (
      <FormInput label={'Users'}>
        <MultiUserSelect
          selectedUsers={access.userIds}
          setSelectedUsers={setUsers}
          isOnlyMarkStaff
        />
      </FormInput>
    )}
  </div>
);

export default AccessInput;
